import React, { useEffect } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import Quill from 'quill';
import { useQuill } from "react-quilljs";
import BlotFormatter2 from '@enzedonline/quill-blot-formatter2';
Quill.register('modules/blotFormatter2', BlotFormatter2);
import s from "quill/dist/quill.snow.css";
import t from '../../../styles/customQuillEditor.css'


let Editor = props => {
  const { quill, quillRef } = useQuill({
    modules: {
      blotFormatter2: {},
      toolbar: [
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],               // custom button values
        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        ['link', 'image', 'video']
      ]
    },
  });

  useEffect(() => {
    if (quill) {
      quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        delta.ops.forEach(op => {
          if (op.attributes) {
            delete op.attributes.color;
            delete op.attributes.background;
          }
        });
        return delta;
      });
      quill.clipboard.dangerouslyPasteHTML(props.value);
      quill.on("text-change", (delta, oldDelta, source) => {
        props.onChange(quill.root.innerHTML);
        if (quill.getText() == "") {
          props.onChange("<p> </p>");
        }
      });
    }
  }, [quill]);

  return (
    <div style={{ width: "100%", height: "100%" }} className='commonQuillBox'>
      <div ref={quillRef} />
    </div>
  );
};

Editor = withStyles(s, t)(Editor);
export { Editor };